module.exports = "pegasus/assets/graycircle-twitter-old.png";